import {useEditableControls,ButtonGroup, IconButton} from '@chakra-ui/react'
import {EditIcon,CloseIcon,CheckIcon} from "@chakra-ui/icons"

export const EditableControls = () => {
  const {isEditing,getSubmitButtonProps,getCancelButtonProps} = useEditableControls();

  return isEditing ? (
    <ButtonGroup justifyContent='center' size='sm'>
      <IconButton icon={<CheckIcon />} {...getSubmitButtonProps()} />
      <IconButton icon={<CloseIcon />} {...getCancelButtonProps()} />
    </ButtonGroup>
  ) : null;
}